var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"mega-menu"},_vm._l((_vm.items),function(item){return _c(_vm.dynamicComponent,{key:item.items_id,tag:"component",attrs:{"item":item,"level":0,"is-mobile-menu":false}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }